module.exports = __webpack_public_path__ + "img/Youtube.41499195.svg";